import type {ReactElement} from 'react';
import {Button, Size, Type} from '@Components/button';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {FixThisButton} from '@Components/social-media/components/fix-this-button';
import type {SocialErrorCardProps} from './social-error-card.types';
import {BADGE_ICON} from './social-error-card.types';
import styles from './social-error-card.module.scss';

export function SocialErrorCard({message, onFixThis, isFixing = false, disabled = false, fixButtonType = 'secondary', secondaryAction}: SocialErrorCardProps): ReactElement {
  const getSecondaryButton = (): ReactElement | null => {
    if (!secondaryAction) {
      return null;
    }
    return <Button type={Type.SECONDARY} size={Size.SMALL} text={secondaryAction.label} onClick={secondaryAction.onClick} />;
  };

  return (
    <div className={styles.card}>
      <div className={styles.badge}>
        <Icon icon={BADGE_ICON} size={IconSize.SIZE_ICON_20} type={IconType.NONE} shape={IconShape.NONE} className={styles.badgeIcon} />
      </div>
      <Text size={TextSize.MD} className={styles.message} val={message} />
      <div className={styles.actions}>
        {getSecondaryButton()}
        <FixThisButton variant={fixButtonType} onClick={onFixThis} isLoading={isFixing} disabled={isFixing || disabled} isFullWidth={!secondaryAction} />
      </div>
    </div>
  );
}
